import './style.scss';
import Group from './group.js';

export default Group;